import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import type { LucideIcon } from 'lucide-react'
import {
  Anchor,
  LayoutDashboard,
  Navigation,
  Map,
  ClipboardList,
  BarChart3,
  FileSpreadsheet,
  Clock,
  Bell,
  Calculator,
} from 'lucide-react'

export type ModuleId = 'home' | 'lng-ops'

export interface NavItem {
  to: string
  icon: LucideIcon
  label: string
}

export interface NavGroup {
  title: string
  items: NavItem[]
}

export interface ModuleDefinition {
  id: ModuleId
  label: string
  description: string
  icon: LucideIcon
  accentColor: string
  basePath: string
  isAvailable: boolean
  navGroups: NavGroup[]
}

export const MODULE_DEFINITIONS: ModuleDefinition[] = [
  {
    id: 'lng-ops',
    label: 'LNG Performance',
    description: 'Voyage performance intelligence for LNG operators',
    icon: Anchor,
    accentColor: '#49F7E2',
    basePath: '/lng-ops',
    isAvailable: true,
    navGroups: [
      {
        title: 'Fleet',
        items: [
          { to: '/lng-ops', icon: LayoutDashboard, label: 'Dashboard' },
          { to: '/lng-ops/live-view', icon: Map, label: 'Live View' },
        ],
      },
      {
        title: 'Performance',
        items: [
          { to: '/lng-ops/voyage-performance', icon: Navigation, label: 'Voyage Perf.' },
          { to: '/lng-ops/calculations', icon: Calculator, label: 'Calculations' },
          { to: '/lng-ops/vessel-reports', icon: ClipboardList, label: 'Vessel Reports' },
        ],
      },
      {
        title: 'Analysis',
        items: [
          { to: '/lng-ops/graphs', icon: BarChart3, label: 'Graphs' },
          { to: '/lng-ops/reports', icon: FileSpreadsheet, label: 'Reports' },
          { to: '/lng-ops/scheduler', icon: Clock, label: 'Scheduler' },
        ],
      },
      {
        title: '',
        items: [
          { to: '/lng-ops/notifications', icon: Bell, label: 'Notifications' },
        ],
      },
    ],
  },
]

export function useActiveModule(): ModuleId {
  const location = useLocation()

  return useMemo(() => {
    const path = location.pathname
    if (path.startsWith('/lng-ops')) return 'lng-ops'
    return 'home'
  }, [location.pathname])
}

export function getModuleDefinition(id: ModuleId): ModuleDefinition | undefined {
  return MODULE_DEFINITIONS.find((m) => m.id === id)
}
